import 'jquery-validation';
/* eslint-disable */
const initValidation = () => {
  initFormAjax();

  jQuery('.form-validation').each((i, form) => {
    const holder = jQuery(form);
    const selects = holder.find('select.choices__input');
    const errorFormClass = 'error-form';
    const errorClass = 'input-error';

    holder.on('submit', (e) => {
      return true;
    });

    if (selects.length) {
      selects.each((i, element) => {
        jQuery(element).removeAttr('hidden').addClass('hidden-select').removeClass('is-hidden');
      });
    }

    const validation = holder.validate({
      errorPlacement(error, element) {
        if (element.is('select') || element.hasClass('custom-file-input') || element.hasClass('custom-control-input')) {
          element.closest('.form-group').append(error);
        } else {
          error.insertAfter(element);
        }
      },
      highlight(element) {
        jQuery(element).closest('.form-group').addClass(errorClass);
        holder.addClass(errorFormClass);
      },
      unhighlight(element) {
        jQuery(element).closest('.form-group').removeClass(errorClass);
      },
      success() {
        setTimeout(() => {
          if (!holder.find(`.${errorClass}`).length) holder.removeClass(errorFormClass);
        }, 50);
      },
      invalidHandler() {
        holder.addClass(errorFormClass);
      },
    });

    selects.on('change', function () {
      validation.element(jQuery(this));
    });
  });

  const form = jQuery('.form-validation2');

  form.validate({
    success(element) {
      console.log(element);
    },
    submitHandler(thisForm) {
      const $thisForm = jQuery(thisForm);

      jQuery.ajax({
        url: $thisForm.attr('action'),
        method: $thisForm.attr('method'),
        data: $thisForm.serialize(),
      });

      jQuery.fancybox.open(jQuery('#newsletter-popup'));

      return false;
    },
  });
};

function initFormAjax() {
  const form = jQuery('.form-validation-ajax');

  if (!form.length) return;

  form.each((i, element) => {
    const holder = jQuery(element);

    holder.on('submit', (e) => {
      e.preventDefault();
    });

    holder.validate({
      submitHandler() {
        jQuery.ajax({
          url: holder.attr('action'),
          method: holder.attr('method'),
          data: holder.serialize(),
          success() {
            holder.addClass('ajax-success').closest('.popup-available').addClass('popup-success');
          },
        });
      },
    });
  });
}

export default initValidation;
/* eslint-enable */
